import React from 'react';
import { useTranslation } from '@lt/localization';
import { ReviewSwiper } from './ReviewsSwiper';

import styles from '../../reviews.module.css';
import type { ReviewsSwiperContainerProps as Props } from './types';

const ReviewsSwiperContainer = ({
  hasReviewsSection,
  totalReviews,
  className,
  items,
  isWhiteLabel,
  hotelReviewsLink,
}: Props): JSX.Element | null => {
  const { t } = useTranslation();
  const slideCount = 3;
  if (!hasReviewsSection) return null;

  return (
    <div className={className}>
      <h2 className={styles.linkTitleMobile}>{t('hotel.reviews.title')}</h2>
      <ReviewSwiper
        totalReviews={totalReviews}
        items={items.slice(0, slideCount)}
        isShowMoreVisible={totalReviews > slideCount}
        isWhiteLabel={isWhiteLabel}
        hotelReviewsLink={hotelReviewsLink}
      />
    </div>
  );
};

export default ReviewsSwiperContainer;
